import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import LoginForm from "./LoginForm";
import RegisterForm from "./RegisterForm";
const AuthForm = () => {
  const [activeTab, setActiveTab] = useState<"login" | "register">("login");
  return <div className="w-full max-w-md">
      <div className="text-center mb-8">
        <h2 className="text-2xl font-bold text-slate-50">
          {activeTab === "login" ? "Welcome Back" : "Create Your Account"}
        </h2>
        <p className="text-white/80 mt-2">
          {activeTab === "login" ? "Sign in to access the package management system" : "Fill in the fields below to register"}
        </p>
      </div>

      <Tabs value={activeTab} onValueChange={value => setActiveTab(value as "login" | "register")} className="w-full">
        <TabsList className="grid w-full grid-cols-2">
          <TabsTrigger value="login">Login</TabsTrigger>
          <TabsTrigger value="register">Register</TabsTrigger>
        </TabsList>

        <TabsContent value="login">
          <LoginForm />
        </TabsContent>

        <TabsContent value="register">
          <RegisterForm />
        </TabsContent>
      </Tabs>
    </div>;
};
export default AuthForm;